if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);

        // Sync quantity from visible input to hidden input before submission
        this.syncQuantityInputs();

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
              if (typeof AOS !== "undefined") {
                AOS.init();
              }
            } else {
              this.cart.renderContents(response);
              if (typeof AOS !== "undefined") {
                AOS.init();
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            if (typeof AOS !== "undefined") {
              AOS.init();
            }
          });
      }

      // Sync quantity from visible input to hidden input (for lottery products)
      syncQuantityInputs() {
        const sectionId = this.dataset.sectionId;
        if (!sectionId) return;

        const visibleInput = document.getElementById(`Quantity-${sectionId}`);
        const hiddenInput = this.form.querySelector(".hidden-quantity-input");

        if (visibleInput && hiddenInput) {
          const quantity = parseInt(visibleInput.value) || 1;
          hiddenInput.value = quantity;
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          if (typeof errorMessage === "object") {
            const formattedMessage = Object.entries(errorMessage)
              .map(([field, messages]) => `${field}: ${messages.join(", ")}`)
              .join(" | ");
            this.errorMessage.textContent = formattedMessage;
          } else {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    }
  );

  let removedElements = {
    mobile: [],
    desktop: [],
  };

  function removeElementsByScreenSize(container = document) {
    if (window.matchMedia("(max-width: 990px)").matches) {
      document.querySelectorAll(".hide-mobile").forEach((el) => {
        removedElements.desktop.push({
          parent: el.parentNode,
          element: el,
          nextSibling: el.nextSibling,
        });
        el.remove();
      });

      removedElements.mobile.forEach(({ parent, element, nextSibling }) => {
        if (nextSibling && nextSibling.parentNode === parent) {
          parent.insertBefore(element, nextSibling);
        } else {
          parent.appendChild(element);
        }
      });
      removedElements.mobile = [];
    } else {
      document.querySelectorAll(".hide-desktop").forEach((el) => {
        removedElements.mobile.push({
          parent: el.parentNode,
          element: el,
          nextSibling: el.nextSibling,
        });
        el.remove();
      });
      removedElements.desktop.forEach(({ parent, element, nextSibling }) => {
        if (nextSibling && nextSibling.parentNode === parent) {
          parent.insertBefore(element, nextSibling);
        } else {
          parent.appendChild(element);
        }
      });
      removedElements.desktop = [];
    }
  }

  removeElementsByScreenSize();
  window.addEventListener("resize", removeElementsByScreenSize);
}

class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this._handleResize = this._debounce(
      this.initStickyAddToCart.bind(this),
      200
    );
  }

  connectedCallback() {
    this.initStickyAddToCart();

    window.addEventListener("resize", this._handleResize);
  }

  disconnectedCallback() {
    if (this._checkVisibility) {
      window.removeEventListener("scroll", this._checkVisibility);
      this._checkVisibility = null;
    }

    window.removeEventListener("resize", this._handleResize);
  }

  initStickyAddToCart() {
    const img = this.querySelector(".product-content img");
    const selectField = this.querySelector('select[name="id"]');
    const addButton = this.querySelector('button[name="add"]');

    // If select has no options yet, StickyAddToCartOptions hasn't run yet — retry
    if (selectField && selectField.options.length === 0) {
      setTimeout(() => this.initStickyAddToCart(), 350);
      return;
    }
    const lotteryAnchor = document.querySelector(".kuji-summary-buy");
    const lotteryBuyBar =
      document.querySelector(".kuji-buy-bar") ||
      document.querySelector(".product-form--bottom");
    const lotteryScrollAnchor =
      document.querySelector(".kjx--overview") ||
      document.querySelector(".kuji-top__row--summary");
    const lotteryMobileTrigger =
      document.querySelector(".buynowfp") ||
      document.querySelector(".kuji-summary-combined") ||
      document.querySelector(".remainingTicketBx") ||
      document.querySelector(".kuji-top");
    const productForms = Array.from(
      document.querySelectorAll('.product-form[data-type="add-to-cart-form"]')
    ).filter((form) => !form.closest("sticky-add-to-cart"));
    const fallbackProductForms = Array.from(
      document.querySelectorAll('.product-form, form[action*="/cart/add"]')
    ).filter((form) => !form.closest("sticky-add-to-cart"));
    const candidateForms = productForms.length ? productForms : fallbackProductForms;
    const primaryProductForm =
      candidateForms.find((form) => form.offsetParent !== null) || candidateForms[0];
    const isVisibleElement = (el) =>
      el && el.offsetParent !== null && el.getClientRects().length > 0;

    let visibilityTarget = null;
    if (isVisibleElement(lotteryAnchor)) {
      visibilityTarget = lotteryAnchor;
    } else if (isVisibleElement(lotteryScrollAnchor)) {
      visibilityTarget = lotteryScrollAnchor;
    } else if (isVisibleElement(lotteryBuyBar)) {
      visibilityTarget = lotteryBuyBar;
    } else if (isVisibleElement(lotteryMobileTrigger)) {
      visibilityTarget = lotteryMobileTrigger;
    } else if (primaryProductForm) {
      visibilityTarget = primaryProductForm;
    } else {
      // Broader fallback: any add-to-cart button or buy-buttons block outside sticky
      visibilityTarget =
        document.querySelector('.buy-buttons-block') ||
        document.querySelector('button[name="add"]:not(sticky-add-to-cart button)') ||
        document.querySelector('.product-info-container') ||
        document.querySelector('#MainProduct-' + (this.dataset.mainSectionId || '')) ||
        document.querySelector('product-info');
    }

    if (!addButton || !visibilityTarget) return;

    const addToCartText = addButton.getAttribute("data-add-to-cart");
    const soldOutText = addButton.getAttribute("data-sold-out");

    const checkVisibility = () => {
      const formRect = visibilityTarget.getBoundingClientRect();
      const footer = document.querySelector("footer");
      const footerRect = footer?.getBoundingClientRect();

      const isOutOfView = formRect.top <= 0;
      const isFooterVisible = footerRect && footerRect.top < window.innerHeight;

      if (isOutOfView && !isFooterVisible) {
        this.classList.add("show");
        document.documentElement.style.paddingBottom = `${this.clientHeight}px`;
      } else {
        this.classList.remove("show");
        document.documentElement.style.paddingBottom = "0";
      }
    };

    checkVisibility();

    if (this._checkVisibility) {
      window.removeEventListener("scroll", this._checkVisibility);
    }
    this._checkVisibility = checkVisibility;
    window.addEventListener("scroll", this._checkVisibility, { passive: true });

    if (selectField) {
      selectField.addEventListener("change", () => {
        const selectedOption = selectField.options[selectField.selectedIndex];

        if (img && selectedOption.dataset.img) {
          img.setAttribute("src", selectedOption.dataset.img);
        }

        if (selectedOption.getAttribute("data-available") === "false") {
          addButton.setAttribute("disabled", "true");
          addButton.querySelector("span").textContent = soldOutText;
        } else {
          addButton.removeAttribute("disabled");
          addButton.querySelector("span").textContent = addToCartText;
        }
      });

      document
        .querySelector('.product-form [name="id"]')
        ?.addEventListener("change", (e) => {
          const value = Number(e.target.value);
          if (value) {
            selectField.value = value;
          }
        });
    }
  }

  _debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

customElements.define("sticky-add-to-cart", StickyAddToCart);
